// src/api/dashboardApi.js
import httpClient from "api/httpClient";

const API_BASE = process.env.REACT_APP_API_URL;

export const dashboardApi = {
  getDashboardData: async () => {
    const response = await httpClient.get(`${API_BASE}/api/dashboard/data`);
    return response.data;
  },
};
